<template>
    <div class="bg-light">
      <div v-for="post in teamBanner" :key="post.id">

        <div class="jumbotron jumbotron-fluid" v-bind:style="{ 'background-image': 'url(' + post.acf.banner + ')' }">
          <div class="container py-5">
            <!--
            <h1 class="display-4 py-5" v-if="post.title.rendered=='Default'">&nbsp;</h1>
            <h1 class="display-4 py-5" v-else>{{ post.title.rendered }}</h1>
            -->
            <h1 class="display-4 py-5">&nbsp;</h1>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Banner",
  created () {
    this.getTeamInfo();
  },
  data() {
    return {
      teamBanner: [],
      endpoint: 'https://careers.pointclickcare.com/wp-json/wp/v2/teams',
      urlSearchParam: this.$route.params.id,
      title: 'Jobs at PointClickCare Careers',
      description : 'Apply for jobs at PointClickCare. Browse our opportunities at PointClickCare and apply today for a position which is relevant to you.'
      // taxonomyTags: {}
    }
  },
  metaInfo () {
    return {
      title: this.title,
      meta: [
        { vmid: 'description', name: 'description', content: this.description }
      ]
    }
  },
  methods: {
     getTeamInfo() {


        if(!this.urlSearchParam){
            this.urlSearchParam = 'Default';
        } 
        // const restUrl = this.endpoint +"?slug="+this.$parent.convertToSlug(this.urlSearchParam);
        const restUrl = this.endpoint +"?slug="+this.urlSearchParam+ "&_fields=id,title,acf";

        // console.log(restUrl);

        this.axios.get(restUrl).then((response) => {
            if(response.data.length>=1){
                this.teamBanner = response.data;
                // console.log(this.teamBanner[0]);
                this.title = this.teamBanner[0].title.rendered + " Jobs at PointClickCare Careers";
                this.description = 'Apply for '+this.teamBanner[0].title.rendered+' jobs at PointClickCare. Browse our opportunities in '+this.teamBanner[0].title.rendered+' Category at PointClickCare and apply today for a position which is relevant to you.';
            } else {
                // console.log('no banner');
                // this.teamBanner = 
            }
            // console.log(restUrl);

            // console.log(this.$route.params.id);
            // console.log(restUrl);
        }).catch(() => { 
          // console.log(error);
        });

    }
  }
};

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >
/* customize boostrap */
#app .jumbotron{
    background-color: #e6e6e6;
    background-repeat: no-repeat;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    /* height: 50vh; */
}
#app .carousel-indicators{
    bottom: -30px;

}
#app .carousel-indicators li{
    background-color: #aeaeae;
    cursor: pointer;
    width: 10px;
    height: 10px;
    border-radius: 100%;
}
#app .carousel-indicators .active{
    background-color: #e66216;
}
#app .carousel-item p {
    line-height: 1.6rem;
}
#app .img-fluid {
    max-height: 300px
}
#app .carousel-caption{
  color: #424242;
  text-align: left;
  left: 0%;
  right: 0%;
  top: 0%;
  padding: 0;
}

</style>
